// extracted by mini-css-extract-plugin
module.exports = {"title":"e_4f","container":"e_5f","right":"e_6f","image":"e_7f","scoreLine":"e_8f","scoreRing":"e_9f","badge":"e_-f","badgeImage":"e_ag","badgeRing":"e_bg","large":"e_cg"};